export { LocationMarker as default } from './LocationMarker';
